import {
    useLocation,
    useNavigate,
    useParams,
} from "react-router-dom";
import React from "react";

// Wrapper to use ReactRouter v6 hooks in class based components
export default function withRouter(Component: React.ComponentType) {
    function ComponentWithRouterProp(props: any) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        return (
            <Component
                {...props}
                router={{ location, navigate, params }}
            />
        );
    }

    return ComponentWithRouterProp;
}
